import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  BusinessCenterOutlined as BusinessCenterOutlinedIcon,
  EmailOutlined as EmailOutlinedIcon,
  LocalPhoneOutlined as LocalPhoneOutlinedIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  TaskOutlined as TaskOutlinedIcon,
} from '@mui/icons-material';

import { campaignsSelectors } from 'store/selectors/campaigns';

import { StatisticTiles } from 'common/components';

import { colors } from 'utils/constants';
import { CardWrapper } from 'globalStyles';

const Title = styled.h2`
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 20px;
`;

const StatisticWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
`;

const CampaignOverview = () => {
  const { campaignDetails } = useSelector(state => ({
    campaignDetails: campaignsSelectors.getCampaignDetails(state),
  }));

  const { statistics } = campaignDetails;

  const tiles = useMemo(() => {
    const options = [
      {
        count: statistics?.advocates?.totalCount,
        icon: (
          <PeopleAltOutlinedIcon
            color="blue"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.people,
        name: 'Advocates',
      },
      {
        count: statistics?.actions?.totalCount,
        icon: (
          <TaskOutlinedIcon
            color="error"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.errorBackground,
        name: 'Actions taken',
      },
      {
        count: statistics?.signatures?.totalCount,
        icon: (
          <TaskOutlinedIcon
            color="error"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.errorBackground,
        name: 'Signatures',
      },
      {
        count: statistics?.phoneCalls?.totalCount,
        icon: (
          <LocalPhoneOutlinedIcon
            color="yellow"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.yellowBackground,
        name: 'Phone Calls',
      },
      {
        count: statistics?.emails?.totalCount,
        icon: (
          <EmailOutlinedIcon
            color="green"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.greenBackground,
        name: 'Emails',
      },
    ];

    return options;
  }, [statistics]);

  const actionAlertTile = useMemo(
    () => [
      {
        count: statistics?.actionCenters?.totalCount,
        icon: (
          <BusinessCenterOutlinedIcon
            color="grey"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.greyBackground,
        name: 'Action Centers',
      },
    ],
    [statistics]
  );

  return (
    <CardWrapper>
      <Title>Overview</Title>
      <StatisticWrapper>
        <StatisticTiles tiles={tiles} />
        <StatisticTiles tiles={actionAlertTile} />
      </StatisticWrapper>
    </CardWrapper>
  );
};

export default CampaignOverview;
